import React from 'react';
import {Route} from 'react-router';

export default ({component: Component, ...rest}) => (
  <Route
    {...rest}
    render={matchProps => (
      <div
        className="kt-grid kt-grid--hor kt-grid--root w-100 h-100"
        style={{position: 'absolute', top: 0}}
      >
        <div
          className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
          style={{backgroundColor: '#FFF'}}
        >
          <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-grid--stretch">
              <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                  <Component {...matchProps} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  />
);
